import React from 'react';
import classnames from 'classnames';
import Breadcrumb from './components/breadcrumb-item';
import classes from './breadcrumbs.scss';
export const BreadcrumbsComponent = ({
  links,
  isLimitedEdition,
  hideForCBSWithLessThen12Products,
  className
}) => !hideForCBSWithLessThen12Products ? /*#__PURE__*/React.createElement("div", {
  className: classnames(classes.container, className)
}, links === null || links === void 0 ? void 0 : links.map((link, key) => /*#__PURE__*/React.createElement(Breadcrumb, {
  key: key,
  link: link,
  className: classnames(classes.item, {
    [classes.disabled]: key === links.length - 1,
    [classes.orangeHover]: isLimitedEdition
  })
}))) : /*#__PURE__*/React.createElement("div", null);